import React, { useEffect, useRef, useState } from "react";
import { IMachine as Machine } from "../../interfaces";
import { useAppSelector } from "../../store/hooks";
import Modal from "./Modal";
import BtnAddTask from "./BtnAddTask";
import { getRandomValues } from "crypto";
import { CurrentUser, getLocalEligibalSub } from "../Service/EndPoints";
import { MenuItem, Select } from "@mui/material";

const InputCheckbox: React.FC<{
  label: string;
  isChecked: boolean;
  setChecked: (value: React.SetStateAction<boolean>) => void;
}> = ({ isChecked, setChecked, label }) => {
  return (
    <label className="mb-0 flex items-center cursor-pointer">
      <div className="mr-2 bg-slate-300/[.5] dark:bg-slate-800 w-5 h-5 rounded-full grid place-items-center border border-slate-300 dark:border-slate-700">
        {isChecked && (
          <span className="bg-[#06B4FF] w-2 h-2 block rounded-full"></span>
        )}
      </div>
      <span className="order-1 flex-1">{label}</span>
      <input
        type="checkbox"
        className="sr-only"
        checked={isChecked}
        onChange={() => setChecked((prev: boolean) => !prev)}
      />
    </label>
  );
};

const ModalCreateMachine: React.FC<{
  onClose: () => void;
  machine?: Machine;
  nameForm: string;
  onConfirm: (machine: Machine) => void;
}> = ({ onClose, machine, nameForm, onConfirm }) => {
  const today: Date = new Date();
  let day: number = today.getDate();
  let month: number = today.getMonth() + 1;
  const year: number = today.getFullYear();
  const machines = useAppSelector((state) => state.machines.machines);
  const [isValid, setIsValid] = useState(false);
 
  if (day < 10) {
    day = +("0" + day);
  }
  if (month < 10) {
    month = +("0" + month);
  }

  const todayDate: string = year + "-" + month + "-" + day;
  const maxDate: string = year + 1 + "-" + month + "-" + day;

  const [description, setDescription] = useState<string>(() => {
    if (machine) {
      return machine.description;
    }
    return "";
  });
  const [title, setTitle] = useState<string>(() => {
    if (machine) {
      return machine.Name;
    }
    return "";
  });

  const [machineId, setmachineId] = useState<string>(() => {
    if (machine) {
      return machine.machineId;
    }
    return "";
  });

  const [date, setDate] = useState<string>(() => {
    if (machine) {
      return machine.date;
    }
    return todayDate;
  });
  const isTitleValid = useRef<Boolean>(false);
  const isDateValid = useRef<Boolean>(false);

  const [isImportant, setIsImportant] = useState<boolean>(() => {
    if (machine) {
      return machine.important;
    }
    return false;
  });

  const [isCompleted, setIsCompleted] = useState<boolean>(() => {
    if (machine) {
      return machine.active;
    }
    return false;
  });

  const [applicationName, setApplicationName] = useState<string>(() => {
    if (machine) {
      return machine.ApplicationName;
    }
    return "";
  });

  const handleSelectChange = (event: any) => {
    setApplicationName(event.target.value);
  };

  const [email, setEmail] = useState<string>(() => {
    if (machine) {
      return CurrentUser().auth.email;
    }
    return CurrentUser().auth.email;
  });
  const randomNumberInRange = (min: any, max: any) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  const addNewTaskHandler = (event: React.FormEvent): void => {
    event.preventDefault();
    if(applicationName ==="" || applicationName==="0")
    {
      setIsValid(false);
      return;
    }
    const filteredMachines = machines.filter((machine: Machine) => {
      return (
        machine.Email === email && machine.ApplicationName === applicationName && machine.machineId === machineId
      );
    });

    if (filteredMachines.length > 0) {
      return;
    }

    isTitleValid.current = title.trim().length > 0;
    isDateValid.current = date.trim().length > 0;

    if (isTitleValid.current && isDateValid.current) {
      const newMachine: Machine = {
        Name: title,
        machineId: machineId,
        description: description,
        date: date,
        active: isCompleted,
        important: isImportant,
        id: randomNumberInRange(1, 100),
        ApplicationName: applicationName,
        Email: email,
        PlanName: "", // get from states
      };
      onConfirm(newMachine);
      onClose();
    }
   

  };
 
  return (
    <Modal onClose={onClose} title={nameForm}>
      <form
        className="flex flex-col stylesInputsField"
        onSubmit={addNewTaskHandler}
      >
        <label>
          Name
          <input
            type="text"
            placeholder="Your name or machine name"
            required
            value={title}
            onChange={({ target }) => setTitle(target.value)}
            className="w-full "
          />
        </label>
        <label>
          Email
          <input
            type="text"
            placeholder="Your 7X membership email"
            required
            disabled
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            className="w-full"
          />
        </label>
        <label>
          Strategy Name
          
          {/* <select
            required
            className="w-full"
            value={applicationName}
            onChange={handleSelectChange}
          >
            <option key={1} value={-1}>
              {""}
            </option>
            {getLocalEligibalSub()
              ? getLocalEligibalSub().map((items: any) => (
                  <option key={items.StrategyName} value={items.StrategyName}>
                    {items.StrategyName}
                  </option>
                ))
              : null}
          </select>
          {!isValid && <p className="text-red-500" >You must choose a value</p>} */}
          <input
            type="text"
            placeholder="Strategy Name"
            required
            value={applicationName}
            onChange={({ target }) => setApplicationName(target.value)}
            className="w-full"
          />
        </label>
        <label>
          Machine Id
          <input
            type="text"
            placeholder="Copy machine Id from ninjatrader 8 application"
            required
            value={machineId}
            onChange={({ target }) => setmachineId(target.value)}
            className="w-full"
          />
        </label>

        <label>
          Date
          <input
            type="date"
            className="w-full"
            value={date}
            required
            onChange={({ target }) => setDate(target.value)}
            min={todayDate}
            max={maxDate}
          />
        </label>
        <label>
          Description (optional)
          <textarea
            placeholder="Notes"
            className="w-full"
            value={description}
            onChange={({ target }) => setDescription(target.value)}
          ></textarea>
        </label>

        <InputCheckbox
          isChecked={isImportant}
          setChecked={setIsImportant}
          label="Mark as active"
        />
        <button
        
          type="submit"
          className="text-[#E4EFF9]  bg-[#06B4FF]  h-[48px] mt-5"
        >
          {nameForm}
        </button>
      </form>
    </Modal>
  );
};

export default ModalCreateMachine;
